import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { categorylist, deletecategorylist } from "../../service/Mainservice";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Deletepopup from "./Aresure";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import Pagination from "../Pagination/pagination";
import ListControls from "../ListControls/ListControls";
import DeleteIcon from "@mui/icons-material/Delete";

const CategoryList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ currentPage: 1 });
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, [sortBy, sortOrder]);

  const getData = async (value) => {
    console.log(value);
    try {
      const response = await categorylist(value, "", { sortBy, sortOrder });
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
  };

  // const handlesearch = async (e) => {
  //   setsearchvalue(e.target.value);
  //   getData(1, e.target.value);
  // };

  const handledelete = async () => {
    try {
      const response = await deletecategorylist(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Categories</h1>
          <div className="data_headdown">
            <h1 className="data_add" onClick={() => navigate("/Add_Category")}>
              <AddIcon /> Add Category
            </h1>

            {/* <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                // onKeyDown={handlesearch}
              />
            </div>*/}
          </div>
        </div>
        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"name",label:"Name"},{value:"id",label:"ID"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        {data ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>
                          <img
                            src={item.image}
                            alt="category"
                            className="categoryimg"
                          />
                        </td>
                        <td>
                          {/* <button
                      // onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button> */}
                          <div style={{ width: "70px" }}>
                            {" "}
                            <EditIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() =>
                                navigate("/Edit_Category", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <DeleteIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No Categories Added Yet</p>
        )}

        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handledelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default CategoryList;
